<template>
  <div class="content5">
    <v-tour :options="tourOptions" name="linkWithApis" :steps="steps"></v-tour>
    <div class="api-title">
      <svg
        width="38"
        height="42"
        viewBox="0 0 38 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.9999 11.5554L18.9999 20.9999M18.9999 20.9999L1.99993 11.5554M18.9999 20.9999L19 39.9999M37 29.117V12.8828C37 12.1975 37 11.8549 36.899 11.5493C36.8097 11.2789 36.6637 11.0308 36.4707 10.8214C36.2526 10.5847 35.9531 10.4183 35.3541 10.0855L20.5541 1.86329C19.9869 1.54817 19.7032 1.39062 19.4029 1.32884C19.1371 1.27417 18.8629 1.27417 18.5971 1.32884C18.2968 1.39062 18.0132 1.54817 17.4459 1.86329L2.64594 10.0855C2.04689 10.4183 1.74737 10.5847 1.52927 10.8214C1.33632 11.0308 1.19029 11.2789 1.10097 11.5493C1 11.8549 1 12.1975 1 12.8828V29.117C1 29.8023 1 30.145 1.10097 30.4506C1.19029 30.7209 1.33632 30.9691 1.52927 31.1785C1.74737 31.4151 2.0469 31.5815 2.64594 31.9143L17.4459 40.1366C18.0132 40.4517 18.2968 40.6092 18.5971 40.671C18.8629 40.7257 19.1371 40.7257 19.4029 40.671C19.7032 40.6092 19.9869 40.4517 20.5541 40.1366L35.3541 31.9143C35.9531 31.5815 36.2526 31.4151 36.4707 31.1785C36.6637 30.9691 36.8097 30.7209 36.899 30.4506C37 30.145 37 29.8023 37 29.117Z"
          stroke="#31006F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <h5>ربط الطلبات</h5>
      <button class="link-package-btn1">
        <a
          class="flex items-center p-1"
          :href="baseUrl + `link-with-api/api-documentation.pdf`"
        >
          <svg
            class="mr-2"
            xmlns="http://www.w3.org/2000/svg"
            width="14.927"
            height="17.415"
            viewBox="0 0 14.927 17.415"
          >
            <path
              id="Icon_metro-file-pdf"
              data-name="Icon metro-file-pdf"
              d="M16.837,5.9a2.261,2.261,0,0,1,.467.739,2.243,2.243,0,0,1,.194.855v11.2a.929.929,0,0,1-.933.933H3.5a.929.929,0,0,1-.933-.933V3.136A.929.929,0,0,1,3.5,2.2h8.708a2.243,2.243,0,0,1,.855.194,2.261,2.261,0,0,1,.739.466ZM12.522,3.525V7.179h3.654a1.062,1.062,0,0,0-.214-.4L12.921,3.739a1.061,1.061,0,0,0-.4-.214Zm3.732,14.85V8.423H12.211a.929.929,0,0,1-.933-.933V3.447H3.815V18.375h12.44Zm-5-5.763a7.4,7.4,0,0,0,.816.544,9.644,9.644,0,0,1,1.137-.068q1.429,0,1.72.476a.47.47,0,0,1,.019.505.028.028,0,0,1-.01.019l-.019.019v.01q-.058.369-.69.369a4.009,4.009,0,0,1-1.118-.194,7.086,7.086,0,0,1-1.263-.515,17.5,17.5,0,0,0-3.81.807Q6.555,17.131,5.69,17.131a.565.565,0,0,1-.272-.068l-.233-.117q-.01-.01-.058-.049a.4.4,0,0,1-.058-.35,2.111,2.111,0,0,1,.544-.889A4.7,4.7,0,0,1,6.9,14.721a.142.142,0,0,1,.224.058.056.056,0,0,1,.019.039q.505-.826,1.04-1.915a14.833,14.833,0,0,0,1.011-2.546,7.856,7.856,0,0,1-.3-1.55,3.779,3.779,0,0,1,.063-1.239q.107-.389.408-.389h.214a.41.41,0,0,1,.34.146.776.776,0,0,1,.087.661.211.211,0,0,1-.039.078.253.253,0,0,1,.01.078v.292A12.726,12.726,0,0,1,9.84,10.3a4.917,4.917,0,0,0,1.419,2.313Zm-5.6,3.994a4.291,4.291,0,0,0,1.331-1.536,5.54,5.54,0,0,0-.85.816A3.23,3.23,0,0,0,5.661,16.606ZM9.529,7.665A2.89,2.89,0,0,0,9.51,8.948q.01-.068.068-.428,0-.029.068-.418a.219.219,0,0,1,.039-.078.028.028,0,0,1-.01-.019.02.02,0,0,0,0-.015.02.02,0,0,1,0-.015.559.559,0,0,0-.126-.35.028.028,0,0,1-.01.019v.019ZM8.324,14.089a14.255,14.255,0,0,1,2.76-.787,1.466,1.466,0,0,1-.126-.092,1.741,1.741,0,0,1-.155-.131,5.148,5.148,0,0,1-1.234-1.71,12.987,12.987,0,0,1-.807,1.915q-.292.544-.437.807Zm6.278-.155a2.326,2.326,0,0,0-1.361-.233,3.676,3.676,0,0,0,1.205.272.943.943,0,0,0,.175-.01q0-.01-.019-.029Z"
              transform="translate(-2.571 -2.203)"
              fill="#212121"
            />
          </svg>
         <span class="font-bold">
          {{ $t('LinkWithApiDocumentationFile') }}
         </span>
        </a>
      </button>
    </div>
    <Tabs :selected="0">
      <Tab title="الإضافة" :steps="2"
        ><link-api
          :link="linkAdd"
          :success="successAdd"
          :apiCode="apiCodeAdd"
          :data="dataAdd"
          :showGovernmentApi="true"
      /></Tab>
      <Tab title="التعديل" :steps="4">
        <link-api
          :link="linkEdit"
          :success="successAdd"
          :apiCode="apiCodeEdit"
          :data="dataEdit"
          :showGovernmentApi="true"
        />
      </Tab>
      <Tab title="البحث" :steps="3">
        <link-api
          :link="linkSearch"
          :success="successSearch"
          :apiCode="apiCodeSearch"
          :data="dataSearch"
        />
      </Tab>
      <Tab title="الحذف" :steps="6">
        <link-api
          :link="linkDelete"
          :success="successDelete"
          :apiCode="apiCodeSearch"
          :data="dataSearch"
        />
      </Tab>
      <Tab title="الطباعة" :steps="16">
        <link-api
          :link="linkPrint"
          :success="successPrint"
          :apiCode="apiCodePrint"
          :data="dataPrint"
          :accept="'text/html'"
        />
      </Tab>
      <Tab title="سجل الطرد" :steps="15">
        <link-api
          :link="linkOrderLogs"
          :success="successOrderLogs"
          :apiCode="apiCodeOrderLogs"
          :data="dataOrderLogs"
          :method="'GET'"
        />
      </Tab>
      <Tab title="الطلبيات" :steps="5">
        <link-api
          :link="linkStatus"
          :success="successStatus"
          :apiCode="apiCodeStatus"
          :data="dataStatus"
        />
      </Tab>
      <Tab :special="true" title="الربط الفوري" :steps="1"
        ><instantLinkApi
      /></Tab>
      <Tab title="طلب إعادة إرسال" :steps="7">
        <link-api
          :link="linkResendRequest"
          :success="successResendRequest"
          :apiCode="apiCodeResendRequest"
          :data="dataResendRequest"
        />
      </Tab>
      <Tab title="طلب إلغاء" :steps="8">
        <link-api
          :link="linkCancel"
          :success="successCancelRequest"
          :apiCode="apiCodeCancelRequest"
          :data="dataCancel"
        />
      </Tab>
      <!-- <Tab title="الطرود المعينة لمهمة" :steps="17">
        <link-api
          :link="linkMissionOrders"
          :success="successMissionOrders"
          :apiCode="apiCodeMissionOrders"
          :data="dataMissionOrders"
          :method="'GET'"
        />
      </Tab> -->
      <Tab title="طلبات المرتجعات">
        <link-api
          :link="linkReturnRequests"
          :success="successReturnRequests"
          :apiCode="apiCodeReturnRequests"
          :data="dataReturnRequests"
          :method="'GET'"
        />
      </Tab>
      <Tab title="الرد علي طلب مرتجع">
        <link-api
          :link="linkHandleReturnRequest"
          :success="successHandleReturnRequest"
          :apiCode="apiCodeHandleReturnRequest"
          :data="dataHandleReturnRequest"
        />
      </Tab>
      <Tab title="طلبات تعديل السعر">
        <link-api
          :link="linkOrderChangeRequests"
          :success="successOrderChangeRequests"
          :apiCode="apiCodeOrderChangeRequests"
          :data="dataOrderChangeRequests"
          :method="'GET'"
        />
      </Tab>
      <Tab title="الرد علي طلب تعديل السعر">
        <link-api
          :link="linkProcessOrderChangeRequests"
          :success="successProcessOrderChangeRequests"
          :apiCode="apiCodeProcessOrderChangeRequests"
          :data="dataProcessOrderChangeRequests"
        />
      </Tab>
      <Tab title="شات الطرد">
        <link-api
          :link="linkMessages"
          :success="successMessages"
          :apiCode="apiCodeMessages"
          :data="dataMessages"
        />
      </Tab>
      <Tab title="نسبة استلام الزبون">
        <link-api
          :link="linkCustomerRate"
          :success="successCustomerRate"
          :apiCode="apiCodeCustomerRate"
          :data="dataCustomerRate"
          :method="'GET'"
        />
      </Tab>
      <Tab title="سجل مكالمات المندوب">
        <link-api
          :link="linkPhoneLog"
          :success="successPhoneLog"
          :apiCode="apiCodePhoneLog"
          :data="dataPhoneLog"
          :method="'GET'"
        />
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import LinkApi from "@/views/components/LinkApi.vue";
import instantLinkApi from "@/views/components/InstantLinkApi.vue";
import Tabs from "@/layouts/components/Tabs.vue";
import Tab from "@/layouts/components/Tab.vue";
import { mapGetters } from "vuex";
import tour from "@/mixins/tour.js";

export default {
  name: "linkWitsApis",
  mixins: [tour],
  data() {
    return {
      steps: [
        {
          target: '[data-link-api-tour-step="1"]', // We're using document.querySelector() under the hood
          header: {
            title: "الربط الفوري",
          },
          content: `من هنا يمكنك الربط اللحظي مع النورس`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="2"]', // We're using document.querySelector() under the hood
          header: {
            title: "اضافة طلب ب API",
          },
          content: `من هنا يمكنك اضافة طلب عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="3"]', // We're using document.querySelector() under the hood
          header: {
            title: "بحث عن طلب ب API",
          },
          content: `من هنا يمكنك بحث طلب عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="4"]', // We're using document.querySelector() under the hood
          header: {
            title: "تعديل طلب ب API",
          },
          content: `من هنا يمكنك تعديل طلب عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="5"]', // We're using document.querySelector() under the hood
          header: {
            title: "معرفة حالة الطلب API",
          },
          content: `من هنا يمكنك معرفة حالة الطلب عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="6"]', // We're using document.querySelector() under the hood
          header: {
            title: "حذف طلب ب API",
          },
          content: `من هنا يمكنك حذف طلب عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="7"]', // We're using document.querySelector() under the hood
          header: {
            title: "طلب إعادة إرسال طرد ب API",
          },
          content: `من هنا يمكنك طلب إعادة إرسال الطرد عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="8"]', // We're using document.querySelector() under the hood
          header: {
            title: "طلب إلغاء طرد ب API",
          },
          content: `من هنا يمكنك طلب إلغاء الطلب عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="9"]', // We're using document.querySelector() under the hood
          header: {
            title: "IDS الفروع",
          },
          content: `من هنا يمكنك معرفة ID كل فرع واستخدامه في API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="10"]', // We're using document.querySelector() under the hood
          header: {
            title: "إنشاء تذكرة دعم ب API",
          },
          content: `من هنا يمكنك إنشاء تذكرة دعم نوعها شكوي والتواصل معنا عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="11"]', // We're using document.querySelector() under the hood
          header: {
            title: "أنواع الشكاوي ب API",
          },
          content: `من هنا يمكنك الحصول علي جميع انواع الشكاوي لإنشاء تذكرة دعم عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="12"]', // We're using document.querySelector() under the hood
          header: {
            title: "إنشاء تذكرة دعم ب API",
          },
          content: `من هنا يمكنك إنشاء تذكرة دعم نوعها استفسار والتواصل معنا عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="13"]', // We're using document.querySelector() under the hood
          header: {
            title: "أنواع الاستفسارات ب API",
          },
          content: `من هنا يمكنك الحصول علي جميع انواع الاستفسارات لإنشاء تذكرة دعم عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="14"]', // We're using document.querySelector() under the hood
          header: {
            title: "إنشاء تذكرة دعم ب API",
          },
          content: `من هنا يمكنك إنشاء تذكرة دعم نوعها شكر أو إقتراح والتواصل معنا عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="17"]',
          header: {
            title: " الطرود المعينة لمهمة API",
          },
          content: `من هنا يمكنك جلب  الطلبيات المعينة لمهمة عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="16"]',
          header: {
            title: "طباعة يوليصة الطلبية  API",
          },
          content: `من هنا يمكنك طباعة بوليصة الطلبية عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '[data-link-api-tour-step="15"]',
          header: {
            title: "تتبع الطلبية  API",
          },
          content: `من هنا يمكنك تتبع سجل الطلبية عن طريق ال API`,
          params: {
            enableScrolling: false,
          },
        },
      ],
      activeChildApi: 0,
      // DATA LINK API ADD
      linkAdd: "add-order",
      successAdd:
        '{"code":"12345","invoice_number":null,"bar_code":"12345","remote_order_id":"6485"}"',
      apiCodeAdd: "",
      apiCodeEdit: "",
      dataAdd: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "main_client_code",
          value: JSON.parse(localStorage.getItem("userData")).clientId,
          descryption: "كود المتجر الرئيسي	",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "second_client",
          value: "احمد",
          descryption: "المتجر الفرعي",
          mandatory: "لا",
          class: "no",
        },
        {
          key: 'remote_order_id', 
          value: '123456', 
          descryption: 'كود الطلبية في السيستم الخاص بكم',
          mandatory: 'ﻻ', 
          class: 'no'
        },
        {
          key: "receiver",
          value: "احمد حسن",
          descryption: "اسم المستلم",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "phone1",
          value: "+218911234567",
          descryption: "رقم تليفون١",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "phone2",
          value: "+218911234567",
          descryption: "رقم تليفون٢",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "government",
          value: "طرابلس",
          descryption: "المدينة",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "area",
          value: "ابوسليم(s19)",
          descryption: "المنطقة",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "address",
          value: "شارع بور سعيد",
          descryption: "العنوان",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "notes",
          value: "الطلب قابل للكسر",
          descryption: "ملاحظات",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "invoice_number",
          value: "27",
          descryption: "رقم الفاتوره",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "order_summary",
          value: "نظارات",
          descryption: "محتوى الطلب",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "amount_to_be_collected",
          value: "100",
          descryption: "سعر المنتج",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "return_amount",
          value: "0",
          descryption: "قيمة الارتجاع",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "api_followup_phone",
          value: "+218911234567",
          descryption: "رقم المتابعة",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "is_order",
          value: "0",
          descryption: `استلام طلب مع التحصيل
              لا = 0
              مرتجع جزئي = 1
              مرتجع استبدال = 2
              مرتجع استرجاع = 3
              4 = استلام عربون`,
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "return_summary",
          value: "نظارة",
          descryption: `محتوي الطلب الراجع
          اجباري في حالة وجود مرتجع,
          is_order = 1 or 2 or 3`,
          mandatory: "لا",
          class: "no",
        },
        {
          key: "is_office_given",
          value: "0",
          descryption: `1 = " الطرد تسليم مكتب"
           0 = " الطرد تسليم عادي"`,
          mandatory: "لا",
          class: "no",
        },
        {
          key: "shipment_on_sender",
          value: "0",
          descryption: `1 = "تكلفة التوصيل على المتجر"
           0 = "تكلفة التوصيل على المستلم"`,
          mandatory: "لا",
          class: "no",
        },{
          key: "extra_cost_payer",
          value: "1",
          descryption: `1 = "التكلفة الاضافيه على المتجر"
           0 = "التكلفة الاضافيه على المستلم"`,
          mandatory: "لا",
          class: "no",
        },       {
          key: "is_fragile",
          value: "0",
          descryption: `اذا كانت الشحنة قابلة للكسر ارسل (1) لتغليفها تغليف آمن واذا كانت غير قابلة للكسر ارسل (0) سيتم اضافة 1 دينار فقط مقابل تغليف خاص يحمي الطلب من الكسر أو التمزق`,
          mandatory: "لا",
          class: "no",
        },   
        {
          key: "can_open",
          value: "1",
          descryption: `1 = "يمكن فتح الشحنة"
           0 = "لا يمكن فتح الشحنة"`,
          mandatory: "لا",
          class: "no",
        },    
        {
          key: "is_measurable",
          value: "1",
          descryption: `1 = "المنتج قابل للقياس"
           0 = "المنتج غير قابل للقياس"`,
          mandatory: "لا",
          class: "no",
        },
        {
          key: "accept_20_plus_5_dinar",
          value: "1",
          descryption: `1 = "يقبل فئات العشرين + الخمسة دينار"
           0 = "لا يقبل فئات العشرين + الخمسة دينار"`,
          mandatory: "لا",
          class: "no",
        },
        {
          key: "is_bank_payment",
          value: "0",
          descryption: "دفع عن طريق الخدمات المصرفية؟ 1= نعم 0= لا",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "payment_commission_payer",
          value: "1",
          descryption: `
          من سيدفع عمولة الخدمة المصرفية ؟
           1 = المستلم
           2 = الراسل`,
          mandatory: "لا",
          class: "no",
        },
        {
          key: "pieces_count",
          value: "1",
          descryption: "عدد القطع",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "products",
          value: `[{"id": 1,"quantity": 1},{"id": 2,"quantity": 1}]`,
          descryption: "منتجات العميل خاصة بالعملاء الذين لديهم خدمة تخزين",
          mandatory: "لا",
          class: "no",
        },
      ],
      dataEdit: [],
      // DATA LINK API SEARCH
      linkSearch: "search-order",
      successSearch:`{
        "success": 1,
        "result": {
          "code": "ror38649",
          "bar_code": "ror38649",
          "remote_order_id":"6485",
          "invoice_number": "env-123-123",
          "status": "محذوفة",
          "status_code": 17
          "returned_inventory_status": "لا يوجد",
          "return_reason": null,
          "delay_reason": null,
          "branch": "لا يوجد",
          "branch_number1": "لا يوجد",
          "branch_number2": "لا يوجد",
          "captain": "لا يوجد",
          "captain_number1": "لا يوجد",
          "captain_number2": "لا يوجد",
          "received_amount": null
        }
      }`,
      apiCodeSearch: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
            "search_Key": "544545454545"
      }`,
      dataSearch: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "search_Key",
          value: "544545454545",
          descryption: "ادخل البار كود او الكود",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      // DATA LINK API PRINT
      linkPrint: "order/print-policy",
      successPrint: `HTML CODE`,
      apiCodePrint: `{
        "authentication_key": "${JSON.parse(localStorage.getItem("userData")).apiToken}",
        "main_client_code": "${JSON.parse(localStorage.getItem("userData")).clientId}",        
        "code": "29018799"
      }`,
      dataPrint: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "main_client_code",
          value: 1,
          descryption: "كود المتجر الرئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "code",
          value: "29018799",
          descryption: "كود الطلب",
          mandatory: "نعم",
          class: "yes",
        }
      ],
      // DATA LINK API EDIT
      linkEdit: "edit-order",
      // DATA LINK API STATUS
      linkStatus: "get-status",
      apiCodeStatus: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
    "from": "2020-09-27",
    "to": "2020-10-01",
    "status": "17"
    }`,
      dataStatus: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "from",
          value: "2020-09-27",
          descryption: "من",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "to",
          value: "2020-09-27",
          descryption: "إلي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "status",
          value: "17",
          descryption: "كود الحالة",
          mandatory: "لا",
          class: "لا",
        },
      ],
      successStatus: `{
        "success": 1,
        "result": [
          {
            "code": "ror38646",
            "bar_code": "ror38646",
            "remote_order_id":"6485",
            "invoice_number": "env-123-123",
            "status": "في الفرع",
            "status_code": 17,
            "returned_inventory_status": "لا يوجد",
            "return_reason": null,
            "delay_reason": null,
            "branch": "Abdelrahman Ramadan Ibrahim Faisal",
            "branch_number1": "+201148993806",
            "branch_number2": "+201148993806",
            "captain": "لا يوجد",
            "captain_number1": "لا يوجد",
            "captain_number2": "لا يوجد",
            "received_amount": 1000
          }
        ]
      }`,
      // DATA LINK API DELELTE
      linkDelete: "delete-order",
      successDelete: '{"status" : 1, "message" : "Deleted Successfully"}',
      linkResendRequest: "resend-request",
      successResendRequest: '{"success": 1,"message": "تم ارسال الطلب بنجاح"}',
      linkCancel: "canceled",
      apiCodeResendRequest: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
            "code": "29018799",
            "type": "1",
            "order_code" : "12345"
      }`,
      apiCodeCancelRequest: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
            "code": "29018799",
            "type": "1",
      }`,
      dataResendRequest: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "code",
          value: "29018799",
          descryption: "ادخل الكود",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "type",
          value: "1",
          descryption: `نوع الطلب 
          1 - طلب اعادة الارسال بنفس البيانات
          2- طلب اعادة الارسال بطرد جديد`,
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "order_code",
          value: "12354",
          descryption:  `كود الطرد الجديد 
          اجباري في حالة لو ,
          type =  2`,
          mandatory: "لا",
          class: "no",
        },
      ],
      dataCancel: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "code",
          value: "29018799",
          descryption: "ادخل الكود",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "type",
          value: "1",
          descryption: "نوع الطلب إلغاء الطرد",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "type",
          value: "0",
          descryption: "نوع الطلب ايقاف الغاء الطرد",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successCancelRequest: '{"success": 1,"message": "تم ارسال الطلب بنجاح"}',
      // DATA LINK API MISSION ORDERS
      linkMissionOrders: "mission-orders",
      apiCodeMissionOrders: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
        "mission_code": "50"
      }`,
      dataMissionOrders: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "mission_code",
          value: "50",
          descryption: "كود المهمة",
          mandatory: "نعم",
          class: "yes",
        }
      ],
      successMissionOrders: `{
        "success": 1,
        "result": [
          {
            "code": "33283N",
            "bar_code": "33283N",
            "remote_order_id":"6485",
            "invoice_number": "env-123-123",
            "receiver": "",
            "execution_date": "2024-11-28 16:44:19",
            "area": null,
            "government": "ابو كماش(s3)",
            "order_summary": "shoes",
            "protection_service": 0,
            "protection_service_percentage": 0,
            "packaging_service": "0",
            "packaging_service_percentage": 0,
            "stock_service": "0",
            "cash_amount": 650,
            "shipment_cost": 50,
            "status": "تم التسليم",
            "status_code": 7,
            "returned_inventory_status": "لا يوجد",
            "return_reason": null,
            "delay_reason": null,
            "branch": "Nawris branch",
            "branch_number1": "0912345678",
            "branch_number2": null,
            "captain": "CAP",
            "captain_number1": "+201001435573",
            "captain_number2": null
          }
        ]
      }`,
      // DATA LINK ORDER LOGS
      linkOrderLogs: "order/logs",
      successOrderLogs: `{
    "success": 1,
    "feed": [
          {
            "message": "تم تعديل حالة الطرد من محفوظة إلي في الشركة هذا الطرد مع الفرع ",
            "created_by": "Nawris branch",
            "created_at": "2025/03/12 03:33:26"
          },
          {
            "message": "تم إضافة هذا الطرد عن طريق الاكسل",
            "created_by": "Nawris branch",
            "created_at": "2025/03/12 03:32:53"
          }
        ]
      }`,
      apiCodeOrderLogs: `{
        "authentication_key": "${JSON.parse(localStorage.getItem("userData")).apiToken}",
        "main_client_code": "${JSON.parse(localStorage.getItem("userData")).clientId}",        
        "code": "29018799"
      }`,
      dataOrderLogs: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "main_client_code",
          value: 1,
          descryption: "كود المتجر الرئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "code",
          value: "29018799",
          descryption: "كود الطلب",
          mandatory: "نعم",
          class: "yes",
        }
      ],
      // DATA LINK API RETURN REQUESTS
      linkReturnRequests: "return-requests",
      apiCodeReturnRequests: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
      "code": "29018799",
      "perPage": "10"
      }`,
      dataReturnRequests: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "code",
          value: "29018799",
          descryption: "كود الطلب (اختياري للبحث)",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "perPage",
          value: "10",
          descryption: "عدد النتائج في الصفحة",
          mandatory: "لا",
          class: "no",
        },
      ],
      successReturnRequests: `{
        "success": 1,
        "response": {
          "feed": [],
          "feed_count": 0
        }
      }`,
      // DATA LINK API HANDLE RETURN REQUEST
      linkHandleReturnRequest: "handle-return-request",
      apiCodeHandleReturnRequest: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
      "code": "29018799",
      "action": "accept",
      "return_request_type": "return_on_receiver"
      }`,
      dataHandleReturnRequest: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "code",
          value: "29018799",
          descryption: "كود الطلب",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "action",
          value: "accept",
          descryption: "accept = قبول , reject = رفض",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "return_request_type",
          value: "return_on_receiver",
          descryption: `نوع طلب المرتجع
          return_on_receiver
          return_without_cost
          return_on_sender
          delayed`,
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successHandleReturnRequest: '{"success": 1,"message": ""}',
      // DATA LINK API ORDER CHANGE REQUESTS
      linkOrderChangeRequests: "get_order_change_requests",
      apiCodeOrderChangeRequests: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
      "order_code": "29018799",
      "per_page": "15"
      }`,
      dataOrderChangeRequests: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "order_code",
          value: "29018799",
          descryption: "كود الطلب (اختياري للتحديد)",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "per_page",
          value: "15",
          descryption: "عدد النتائج في الصفحة",
          mandatory: "لا",
          class: "no",
        },
      ],
      successOrderChangeRequests: `{
        "success": 1,
        "order_change_requests": [],
        "pagination": {
          "total": 0,
          "per_page": 15,
          "current_page": 1,
          "last_page": 1
        }
      }`,
      // DATA LINK API PROCESS ORDER CHANGE REQUESTS
      linkProcessOrderChangeRequests: "process_order_change_requests",
      apiCodeProcessOrderChangeRequests: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
      "code": "29018799",
      "accept": "1",
      "partial_return": "0"
      }`,
      dataProcessOrderChangeRequests: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "code",
          value: "29018799",
          descryption: "كود الطلب",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "accept",
          value: "1",
          descryption: "1 = قبول تعديل السعر , 0 = رفض تعديل السعر",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "partial_return",
          value: "0",
          descryption: "1 = يوجد مرتجع جزئي , 0 = لا يوجد",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successProcessOrderChangeRequests: `{
        "success": 1,
        "order_change_request": {},
        "message": ""
      }`,
      // DATA LINK API MESSAGES
      linkMessages: "messages",
      apiCodeMessages: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
      "order_code": "29018799"
      }`,
      dataMessages: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "order_code",
          value: "29018799",
          descryption: "كود الطلب",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successMessages: `{
        "success": 1,
        "code": "29018799",
        "receiver": "احمد حسن",
        "captain": "لا يوجد",
        "branch": "لا يوجد",
        "client": "احمد",
        "client_status": 7,
        "can_send": true,
        "messages": []
      }`,
      // DATA LINK API CUSTOMER RATE
      linkCustomerRate: "customer-rate",
      apiCodeCustomerRate: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
      "phone1": "+218911234567"
      }`,
      dataCustomerRate: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "phone1",
          value: "+218911234567",
          descryption: "رقم تليفون الزبون",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successCustomerRate: `{
        "success": 1,
        "message": "existing customer",
        "rate": 85.5,
        "total": 20,
        "delivered": 17,
        "returned": 3
      }`,
      // DATA LINK API PHONE LOG
      linkPhoneLog: "order/phone-log",
      apiCodePhoneLog: `{"authentication_key": "${
        JSON.parse(localStorage.getItem("userData")).apiToken
      }",
      "code": "29018799"
      }`,
      dataPhoneLog: [
        {
          key: "authentication_key",
          value: JSON.parse(localStorage.getItem("userData")).apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "code",
          value: "29018799",
          descryption: "كود الطلب",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successPhoneLog: `{
        "success": 1,
        "feed": [
          {
            "id": 1,
            "captain_name": "CAP",
            "receiver_phone": "+218911234567",
            "captain_phone": "+218921234567",
            "type": "outgoing",
            "type_text": "مكالمة صادرة",
            "is_received": 1,
            "duration": "35",
            "rington_duration": "5",
            "status": "answered",
            "call_date": "2025-03-12 03:33:26",
            "created_at": "2025-03-12 03:33:26"
          }
        ]
      }`,
      baseUrl: process.env.VUE_APP_BASE_URL_EXCEL,
    };
  },
  components: {
    LinkApi,
    instantLinkApi,
    Tabs,
    Tab,
  },
  computed: {
    ...mapGetters("userData", ["client"]),
  },
  mounted() {
    this.dataEdit = this.dataAdd.filter(el=>el.key!=="extra_cost_payer");
    this.dataEdit.push({
      key: "code",
      value: 123456789,
      descryption: "كود الطلب",
      mandatory: "نعم",
      class: "yes",
    });
    this.apiCodeAdd = `{"authentication_key": "${
      JSON.parse(localStorage.getItem("userData")).apiToken
    }",
    "main_client_code": "${
      JSON.parse(localStorage.getItem("userData")).clientId
    }",
    "remote_order_id": "123456",
    "second_client":"محمد فريد",
    "receiver":"عبدالرحمن رمضان ",
    "phone1":"+218911234567",
    "phone2":"+218911234567",
    "api_followup_phone":"+218911234567",
    "government":"طرابلس",
    "area":"ابوسليم(s19)",
    "address":"شارع بورسعيد",
    "notes":"الطلب قابل للكسر",
    "invoice_number":"env-123-123",
    "order_summary":"نظارة",
    "amount_to_be_collected": 100,
    "return_amount":0,
    "is_order": 0,
    "return_summary":"نظارة",
    "is_office_given": 0,
    "shipment_on_sender": 0,
    "extra_cost_payer": 1,
    "is_fragile": 0,
    "can_open": 1,
    "is_measurable": 1,
    "accept_20_plus_5_dinar": 1,
    "pieces_count": 1,
    "is_bank_payment": 0,
    "payment_commission_payer": 1,
    "products": [
        {
            "id": 1,
            "quantity": 1
        },
        {
            "id": 2,
            "quantity": 1
        }
    ]
  }`;
    this.apiCodeEdit = `{"authentication_key": "${
      JSON.parse(localStorage.getItem("userData")).apiToken
    }",
    "main_client_code": ${
      JSON.parse(localStorage.getItem("userData")).clientId
    },
    "code": "259654",
    "second_client":"محمد فريد",
    "receiver":"عبدالرحمن رمضان ",
    "phone1":"+218911234567",
    "phone2":"+218911234567",
    "api_followup_phone":"+218911234567",
    "government":"طرابلس",
    "area":"ابوسليم(s19)",
    "address":"شارع بورسعيد",
    "notes":"الطلب قابل للكسر",
    "invoice_number":"env-123-123",
    "order_summary":"نظارة",
    "amount_to_be_collected": 100,
    "return_amount": 0,
    "is_order": 0,
    "return_summary":"نظارة",
    "is_office_given": 0,
    "is_fragile": 0,
    "can_open": 1,
    "is_measurable": 1,
    "accept_20_plus_5_dinar": 1,
    "pieces_count": 1,
    "is_bank_payment": 0,
    "payment_commission_payer": 1,
    "products": [
        {
            "id": 1,
            "quantity": 1
        },
        {
            "id": 2,
            "quantity": 1
        }
    ]
  }`;
    this.$watch(
      () => {
        return this.$tours.linkWithApis.currentStep;
      },
      (val) => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    );
    if (this.runWalkthrough()) {
      this.startTour("linkWithApis");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_setting.scss";
</style>
